export enum ProductLoaderOrigin {
    CATEGORY = 'category',
    RELATEDS = 'relateds',
    SEARCH = 'search',
}
